import PropTypes from 'prop-types';
import React from 'react';
import { datesService } from '../../services/DatesService';
import Loader from "../utils/Loader";
import useDocumentBreakpoint from '@/hooks/useDocumentBreakpoint';

const ListingToolbar = (props) => {
    const { toolbarDefaultDateFormat } = datesService();
    const { isDesktopCalendar } = useDocumentBreakpoint();

    return (
        <div className="org-listing-calendar__toolbar">
            <div className="org-listing__toolbar__navigation">
                <button className="button button--tertiary" onClick={props.onPrevious} disabled={!!props.loading || !!props.previousDisabled}>
                    <i className={isDesktopCalendar ? 'icon-arrow_back' : 'icon-navigate_before'} aria-hidden="true"></i>
                    <span className="text-sm-medium">Previous</span>
                </button>

                <span className={isDesktopCalendar ? 'text-lg-medium' : 'text-md-bold'}>
                    {toolbarDefaultDateFormat(props.date)}
                </span>

                <button className="button button--tertiary" onClick={props.onNext} disabled={!!props.loading || !!props.nextDisabled}>
                    <span className="text-sm-medium">Next</span>
                    <i className={isDesktopCalendar ? 'icon-arrow_forward' : 'icon-navigate_next'} aria-hidden="true"></i>
                </button>
            </div>

            {props.loading && <Loader loaded={props.loading} />}
        </div>
    );
}

ListingToolbar.propTypes = {
    onPrevious: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    date: PropTypes.instanceOf(Date),
    loading: PropTypes.bool,
    previousDisabled: PropTypes.bool,
    nextDisabled: PropTypes.bool
};

export default ListingToolbar;
